// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price-row:hover{
    background-color: #BFCFFF !important;
    transform: scale(1.01);
}



.price-table::-webkit-scrollbar-thumb {
    display: none;
}



.download-btn{
    font-size: 11px !important;
    margin-right: 5px !important;
    margin-bottom: 10px !important;
}

.upload-btn{
    font-size:11px !important;
    margin-right: 20px !important;
    margin-bottom: 10px !important;
}
.table-tabs{
    margin-top: -10px !important;
    margin-bottom: 10px !important;
}

.table-tabs>div:first-child{
    position: relative !important;
    z-index: 1 !important;
    margin-top: 0px !important;
    justify-content: flex-start !important;
    width: -moz-fit-content !important;
    width: fit-content !important;
    margin-left: 30px !important;
    
}
.table-tabs>div:first-child>div:first-child{
    margin-left: 0px !important;
    border: none !important;
    margin-top: -18px !important;
}

.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected{
    border: 1px solid #0000ff;
    border-radius: 10px;
    color: #0000ff !important;

}

.table-tabs>div:first-child>div:first-child>button{
    font-size: 13px !important;
    padding: 5px !important;
    min-height: 25px !important;
    margin-right: 10px !important;
}

.table-cell-pricing{
    font-size: 12px !important;
    padding: 12px !important;
}


@media screen and (max-width:840px) {
    
    .table-tabs>div:first-child{
        display: flex;
        flex-direction: row;
    }
}


.card{
    /* display: inline-block; */
    display: flex;
    /* border: 1px solid #eee; */
    box-shadow: 0 0px 5px #ccc;
    width: 80%;
    padding : 5px;
    margin: 20px;
    border-radius: 5px;
  }


  .card>div{
    width: 50%;
    margin: 10px;
  }

  .card strong{
    color: #02098d;
  }`, "",{"version":3,"sources":["webpack://./src/components/Radiologists/RadPricing.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;AACjB;;;;AAIA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,0BAA0B;IAC1B,sCAAsC;IACtC,kCAA6B;IAA7B,6BAA6B;IAC7B,4BAA4B;;AAEhC;AACA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;;AAE7B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;AAC5B;;;AAGA;;IAEI;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;;AAGA;IACI,2BAA2B;IAC3B,aAAa;IACb,4BAA4B;IAC5B,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,YAAY;IACZ,kBAAkB;EACpB;;;EAGA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".price-row:hover{\n    background-color: #BFCFFF !important;\n    transform: scale(1.01);\n}\n\n\n\n.price-table::-webkit-scrollbar-thumb {\n    display: none;\n}\n\n\n\n.download-btn{\n    font-size: 11px !important;\n    margin-right: 5px !important;\n    margin-bottom: 10px !important;\n}\n\n.upload-btn{\n    font-size:11px !important;\n    margin-right: 20px !important;\n    margin-bottom: 10px !important;\n}\n.table-tabs{\n    margin-top: -10px !important;\n    margin-bottom: 10px !important;\n}\n\n.table-tabs>div:first-child{\n    position: relative !important;\n    z-index: 1 !important;\n    margin-top: 0px !important;\n    justify-content: flex-start !important;\n    width: fit-content !important;\n    margin-left: 30px !important;\n    \n}\n.table-tabs>div:first-child>div:first-child{\n    margin-left: 0px !important;\n    border: none !important;\n    margin-top: -18px !important;\n}\n\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected{\n    border: 1px solid #0000ff;\n    border-radius: 10px;\n    color: #0000ff !important;\n\n}\n\n.table-tabs>div:first-child>div:first-child>button{\n    font-size: 13px !important;\n    padding: 5px !important;\n    min-height: 25px !important;\n    margin-right: 10px !important;\n}\n\n.table-cell-pricing{\n    font-size: 12px !important;\n    padding: 12px !important;\n}\n\n\n@media screen and (max-width:840px) {\n    \n    .table-tabs>div:first-child{\n        display: flex;\n        flex-direction: row;\n    }\n}\n\n\n.card{\n    /* display: inline-block; */\n    display: flex;\n    /* border: 1px solid #eee; */\n    box-shadow: 0 0px 5px #ccc;\n    width: 80%;\n    padding : 5px;\n    margin: 20px;\n    border-radius: 5px;\n  }\n\n\n  .card>div{\n    width: 50%;\n    margin: 10px;\n  }\n\n  .card strong{\n    color: #02098d;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
